import '../../App.css'
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid'
import Button from '@mui/material/Button'
import EditIcon from '@mui/icons-material/Edit';
import { SelectGenericFromTable } from '../universal/Axios';
import { getStore } from '../../Store'
import { observer } from "mobx-react"
import { GetPerformancePercentile } from '../universal/InternalCalculator';
import { useState } from 'react';
import { CustomToolbar } from '../universal/GridHelper';
const store = getStore();


const NetworkRunTable = observer(({ setNetworkRunID }) => {
    const { push } = useHistory();
    //const networkRunData = store.networkRuns
    const [networkRunData, setNetworkRunData] = useState(undefined)

    useEffect(() => {
        SelectGenericFromTable("select nr.id, nr.name, nrq.network_batch_id, nr.signal_noise_separation_input_id, nrq.audio_file_name, nr.description, nr.audio_source_folder, nrq.run_date, nr.run_by, nr.is_archived, nrq.si_sdr from network_run nr left join network_run_queue nrq on nrq.network_run_id = nr.id order by nrq.run_date desc limit 2000;", setNetworkRunData)
    }, []);


    if (networkRunData === undefined) {
        return (<p>loading...</p>)
    }

    const editNetworkRun = (networkRunRow) => {
        store.updateCurrentNetworkRun(networkRunRow.row)
        push('edit-network-run')
    }

    const networkRunColumns = [
    {
        field: 'id',
        headerName: 'Actions',
        width: 70,
        renderCell: (params) => (
            <>
                <Button
                    href="#"
                    onClick={() => editNetworkRun(params)}
                >
                    <EditIcon />
                </Button>
            </>
        ),
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 400,
        },
        {
            field: 'audio_file_name',
            headerName: 'Audio File Name',
            width: 380,
        },
        {
            field: 'si_sdr',
            headerName: 'SI-SDR',
            width: 80,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_performance)) * 255) + ',' + (parseFloat(params.row.relative_performance) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'actions',
            headerName: '',
            width: 105,
            renderCell: (params) => (
                <>
                    <a href={"/output-files?id=" + params.row.id + "&insi_id=" + params.row.signal_noise_separation_input_id} target="_blank">
                        <Button
                        variant="contained"
                        style={{ textTransform: "none", marginRight: "5px" }}
                        >
                            Output
                        </Button>
                    </a>
                </>
            ),
        },
        {
            field: 'network_batch_id',
            headerName: 'Network Batch ID',
            width: 340,
        },
        {
            field: 'audio_source_folder',
            headerName: 'Audio Folder',
            width: 220
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 520
        },
        {
            field: 'signal_noise_separation_input_id',
            headerName: 'signal_noise_separation_input_id',
            hide: true
        },
        {
            field: 'is_archived',
            headerName: 'Archived',
            width: 120,
            renderCell: (params) => (
                params.row.is_archived ? "Yes" : "No"
            ),
        }
    ];

    let networkRunDataRows = networkRunData?.filter(data => data != null).map((networkRun) =>
    ({   
        id: networkRun.id,
        name: networkRun.name,
        description: networkRun.description,
        audio_source_folder: networkRun.audio_source_folder,
        is_archived: networkRun.is_archived,
        run_date: networkRun.run_date,
        run_by: networkRun.run_by,
        si_sdr: networkRun.si_sdr,
        network_batch_id: networkRun.network_batch_id,
        audio_file_name: networkRun.audio_file_name,
        signal_noise_separation_input_id: networkRun.signal_noise_separation_input_id,
    }))
    networkRunDataRows = GetPerformancePercentile(networkRunDataRows, 'si_sdr', 'relative_performance', 0);

    return (
        <DataGrid
            disableSelectionOnClick
            rows={networkRunDataRows}
            columns={networkRunColumns}
            pagination={true}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'name', sort: 'desc' }, { field: 'audio_source_folder', sort: 'desc'}],
              },
            }}
            components={{
                Toolbar: () => CustomToolbar("Network_Runs")
            }}
      />
    )
});

export { NetworkRunTable };
